import { render, staticRenderFns } from "./AppListItem.vue?vue&type=template&id=5a378426&scoped=true&"
import script from "./AppListItem.vue?vue&type=script&lang=ts&"
export * from "./AppListItem.vue?vue&type=script&lang=ts&"
import style0 from "./AppListItem.vue?vue&type=style&index=0&id=5a378426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a378426",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemAction,VListItemContent,VListItemSubtitle})
